function runSetUtmCookieToDirect(jsCookie) {
	jsCookie.set(
		runUtmCookieKey(),
		JSON.stringify({
			UTM_Medium__c: 'website',
			UTM_Source__c: 'direct',
			UTM_Campaign__c: 'not set',
			UTM_Content__c: 'not set',
			UTM_Term__c: 'not set',
			GCLID__c: 'not set',
			icid: 'not set'
		}),
		{expires: runUtmCookieExpiration()}
	);
}